import React, { Fragment, useEffect, useState } from 'react';
import HomeOpenHours from '../components/HomeOpenHours';
import ScrollIntoView from '../components/ScrollIntoView';
// import posts from process.env.PUBLIC_URL + '/actual/posts.json'

const Home = () => {

  const [posts, setPosts] = useState(null)
  
  useEffect(() => {
    
    if(!posts) {

      fetch(process.env.PUBLIC_URL + '/actual/posts.json')
      .then(response => {
        response.json()
        .then(data => {
          setPosts(data)
        })
      })
      .catch(err => {
        console.log(err)
      }) 
      
    }
      
  })

  return (
    <ScrollIntoView>

      <div id="home-page">
        
        <section id="home-actual">
          <h1>Aktuális</h1>

          <article>

            {posts && posts.map((item,index) => {
              return (
                <Fragment key={index}>
                  <h2>{item.title}</h2>
                  {<div dangerouslySetInnerHTML={{__html: item.content}}></div>}
                </Fragment>
              )
            })}

          </article>

        </section>

        <section id="home-office">
        </section>

        <HomeOpenHours />

      </div>
    </ScrollIntoView>
  );
};

export default Home;